<h2 mat-dialog-title>Enviar datos a la métrica</h2>
<div mat-dialog-content class="ingest-help">
  <p class="intro">
    Guía rápida para que un desarrollador empiece a enviar valores a la métrica asociada a
    <strong>{{ data.key_result_title }}</strong
    >.
  </p>

  <div class="field">
    <div class="field-header">
      <span class="label">Slug de la métrica</span>
      <button mat-icon-button type="button" matTooltip="Copiar" (click)="copy(data.company_metric_slug)">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
    <code>{{ data.company_metric_slug }}</code>
  </div>

  <div class="field">
    <span class="label">Endpoint</span>
    <mat-button-toggle-group
      class="endpoint-mode"
      [value]="endpoint_mode()"
      (change)="setEndpointMode($event.value)"
      hideSingleSelectionIndicator
    >
      <mat-button-toggle value="current">{{ current_label() }}</mat-button-toggle>
      <mat-button-toggle value="legacy">{{ legacy_label() }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  @if (help() === null) {
    <p class="warning">Cargando ejemplo de payload…</p>
  } @else if (show_legacy_company_warning()) {
    <p class="warning">
      Esta métrica es de nivel <strong>empresa</strong>. El contrato legacy de
      <strong>project / company-product business analytics dashboard</strong> solo acepta métricas de <strong>producto</strong>. Cambia a
      <strong>Current</strong> para ver la URL y el ejemplo de payload.
    </p>
  } @else if (show_legacy_missing_uuid()) {
    <p class="warning">No se ha podido resolver el UUID del producto para construir el endpoint legacy.</p>
  } @else if (show_ingest_details()) {
    <div class="field">
      <div class="field-header">
        <span class="label">URL</span>
        <button mat-icon-button type="button" matTooltip="Copiar" (click)="copy(endpoint()!)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <code>POST {{ endpoint() }}</code>
    </div>

    @if (show_current_contract_notes()) {
      <div class="notes">
        <p>
          Un único array <strong>company_metric_sections</strong>: cada sección declara <code class="inline">relatable_type</code> (<code
            class="inline"
            >company</code
          >
          o <code class="inline">company_product</code>) y anida sus <code class="inline">company_metrics</code>.
        </p>
        <p>
          URL actual:
          <code class="inline">.../companies/{{ '{' }}uuid{{ '}' }}/company-metrics</code>.
        </p>
        <p>
          Campos principales de cada métrica: <code class="inline">value</code>, <code class="inline">value_unit</code>,
          <code class="inline">bootstrap_class</code> (layout en health metrics) y <code class="inline">section_order</code> (orden de la
          métrica en su sección; distinto del order del Key Result en el OKR).
        </p>
        <p>
          <code class="inline">visualizations</code> es opcional. Cada ítem lleva <code class="inline">json</code> con las opciones de
          ApexCharts.
        </p>
        <p>
          Documentación ApexCharts:
          <a [href]="apexcharts_docs_url" target="_blank" rel="noopener noreferrer">
            apexcharts.com/docs/options
            <mat-icon class="link-icon">open_in_new</mat-icon>
          </a>
        </p>
      </div>
    }

    @if (show_legacy_contract_notes()) {
      <div class="notes">
        <p>
          Contrato antiguo de
          <strong>project business analytics dashboard</strong>. URL legacy:
          <code class="inline">…/projects/{{ '{' }}uuid{{ '}' }}/project-business-analytics-dashboard</code>.
        </p>
        <p>
          El payload usa claves legacy como
          <code class="inline">project_business_analytics_dashboard_sections</code>. El backend las mapea y reenvía al ingest canónico de
          company.
        </p>
      </div>
    }

    @if (show_current_contract_notes() && company_uuid()) {
      <div class="field">
        <div class="field-header">
          <span class="label">UUID de la empresa</span>
          <button mat-icon-button type="button" matTooltip="Copiar" (click)="copy(company_uuid()!)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
        <code>{{ company_uuid() }}</code>
      </div>
    }

    @if (is_product_metric && company_product_uuid() && show_legacy_contract_notes()) {
      <div class="field">
        <div class="field-header">
          <span class="label">UUID del producto</span>
          <button mat-icon-button type="button" matTooltip="Copiar" (click)="copy(company_product_uuid()!)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
        <code>{{ company_product_uuid() }}</code>
      </div>
    }

    <div class="field">
      <div class="field-header">
        <span class="label">Ejemplo de payload</span>
        <button mat-icon-button type="button" matTooltip="Copiar" (click)="copy(example_payload())">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <pre>{{ example_payload() }}</pre>
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button color="accent" type="button" (click)="close()">Cerrar</button>
</div>
